import { useState, useEffect } from 'react';
import { useQuery } from 'data-fetching-client';
import I18n from 'I18n';
import { OptimisticNanoProgress } from 'foundations-components/transitional/components/OptimisticNanoProgress';
import { WORKFLOWS_APP } from 'automation-ui-source-apps/constants/SourceApps';
import { isFilterEmpty } from 'automation-ui-flow-core/enrollment/enrollmentUtils';
import ReenrollmentSelect from 'automation-ui-enrollment/components/ReenrollmentSelect';
import ScheduledEnrollmentReenrollmentTab from 'automation-ui-enrollment/components/scheduledEnrollment/ScheduledEnrollmentReenrollmentTab';
import EventReenrollmentView from 'automation-ui-enrollment/components/eventEnrollment/EventReenrollmentView';
import ReenrollmentConfig from 'automation-ui-canvas/components/enrollment/ReenrollmentConfig';
import { GET_RE_ENROLLMENT_FILTERS_FROM_FILTER_BRANCH } from 'automation-ui-enrollment/queries/ReenrollmentQueries';
import { getEnrollmentList } from 'automation-ui-enrollment/utils/listFilters';
import { applyReenrollment } from 'automation-ui-canvas/create/utils/applyReenrollment';
import { jsx as _jsx } from "react/jsx-runtime";
const EMPTY_FILTER_BRANCH = {
  filterBranches: [],
  filterBranchOperator: 'OR',
  filterBranchType: 'OR',
  filters: []
};
export default function ReenrollmentStep({
  selectedTriggerOption,
  objectTypeId,
  flow,
  setFlow
}) {
  var _getEnrollmentList$fi, _getEnrollmentList;
  const [reenrollmentState, setReenrollmentState] = useState([]);
  const shouldReenroll = flow.shouldReenroll;
  const filterBranch = (_getEnrollmentList$fi = (_getEnrollmentList = getEnrollmentList(flow)) === null || _getEnrollmentList === void 0 ? void 0 : _getEnrollmentList.filterBranch) !== null && _getEnrollmentList$fi !== void 0 ? _getEnrollmentList$fi : EMPTY_FILTER_BRANCH;
  const {
    data,
    loading
  } = useQuery(GET_RE_ENROLLMENT_FILTERS_FROM_FILTER_BRANCH, {
    skip: selectedTriggerOption.type !== 'LIST',
    variables: {
      enrollmentCriteria: isFilterEmpty(filterBranch) ? null : filterBranch,
      isClassicWorkflow: 'classicEnrollmentSettings' in flow,
      existingAssociatedLists: [],
      existingFlowEventFilters: [],
      existingReEnrollmentTriggerSets: []
    }
  });
  useEffect(() => {
    if (data !== null && data !== void 0 && data.getReenrollmentFiltersFromFilterBranch) {
      const newReenrollmentState = data.getReenrollmentFiltersFromFilterBranch.reEnrollmentTriggers;
      setReenrollmentState(newReenrollmentState);
      setFlow(draftFlow => {
        applyReenrollment(draftFlow, shouldReenroll, newReenrollmentState);
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);
  const handleReenrollmentStateChange = newReenrollmentState => {
    setReenrollmentState(newReenrollmentState);
    setFlow(draftFlow => {
      applyReenrollment(draftFlow, shouldReenroll, newReenrollmentState);
    });
  };
  if (loading) {
    return /*#__PURE__*/_jsx(OptimisticNanoProgress, {});
  }
  const handleShouldReenrollChange = newShouldReenroll => {
    let newReenrollmentState = reenrollmentState;
    if (!shouldReenroll && newShouldReenroll) {
      // When toggling reenrollment on, enable for all supported triggers
      newReenrollmentState = newReenrollmentState.map(reenrollmentStateItem => Object.assign({}, reenrollmentStateItem, {
        checked: reenrollmentStateItem.reEnrollmentTrigger.type !== 'NOT_SUPPORTED'
      }));
      setReenrollmentState(newReenrollmentState);
    }
    setFlow(draftFlow => {
      applyReenrollment(draftFlow, newShouldReenroll, newReenrollmentState);
    });
  };
  if (selectedTriggerOption.type === 'SCHEDULED') {
    return /*#__PURE__*/_jsx(ScheduledEnrollmentReenrollmentTab, {
      flowObjectTypeId: objectTypeId
    });
  } else if (selectedTriggerOption.type === 'EVENT') {
    return /*#__PURE__*/_jsx(EventReenrollmentView, {
      objectTypeId: objectTypeId,
      shouldReenroll: shouldReenroll,
      setShouldReenroll: handleShouldReenrollChange
    });
  } else if (selectedTriggerOption.type === 'LIST') {
    return /*#__PURE__*/_jsx(ReenrollmentConfig, {
      objectTypeId: objectTypeId,
      reenrollmentState: reenrollmentState,
      onReenrollmentStateChange: handleReenrollmentStateChange,
      shouldReenroll: shouldReenroll,
      onShouldReenrollChange: handleShouldReenrollChange,
      numOrphanedTriggers: 0,
      sourceApp: WORKFLOWS_APP
    });
  } else {
    return /*#__PURE__*/_jsx(ReenrollmentSelect, {
      objectTypeId: objectTypeId,
      shouldReenroll: shouldReenroll,
      setShouldReenroll: handleShouldReenrollChange
    });
  }
}
export const reenrollmentStep = {
  component: ReenrollmentStep,
  getLabel: () => I18n.text('createWorkflow.step.enrollmentSettings')
};